  <template>
  <div style="padding-left:5px;padding-right:5px;">
    <ChatDetailDialog
      :dialog="showChatDetailDialog"
      :chat="chat"
      @close="closeChatDetailDialog"
    >
    </ChatDetailDialog>

    <v-data-table
      class="mt-5"
      single-select
      :footer-props="{ disableItemsPerPage: true, }"
      :headers="headers"
      :loading="busy"
      :items="chats"
      :items-per-page="10"
      :server-items-length="serverItemsLength"
      :options.sync="options"
    >
      <template v-slot:item.isOpen="{ item }">
        {{item.isOpen ? 'yes' : 'no'}}
      </template>

      <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" @click.stop="loadAndShowChatDetailDialog(item)" v-on="on">zoom_in</v-icon>
          </template>
          <span>View Chat Details</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>

</template>

<script>
import moment from 'moment';
import ChatDetailDialog from './ChatDetailDialog.vue';

export default {
  components: {
    ChatDetailDialog,
  },
  data() {
    return {
      headers: [
        {
          text: 'Session ID',
          align: 'left',
          sortable: false,
          value: 'sessionId',
          width: 100,
        },
        {
          text: 'Serial Number',
          align: 'left',
          sortable: false,
          value: 'serialNumber',
          width: 100,
        },
        {
          text: 'Open',
          align: 'left',
          sortable: false,
          value: 'isOpen',
          width: 100,
        },
        {
          text: 'Created At',
          align: 'left',
          sortable: false,
          value: 'createdAt',
          width: 250,
        },
        {
          text: 'Updated At',
          align: 'left',
          sortable: false,
          value: 'updatedAt',
          width: 250,
        },
        {
          text: 'Actions',
          align: 'left',
          sortable: false,
          value: 'action',
          width: 150,
        },
      ],
      chats: [],
      busy: false,
      serverItemsLength: 0,
      options: {},
      chat: {},
      showChatDetailDialog: false,
    };
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      const options = {
        method: 'get',
        url: `https://alignergpt.com/chat_sessions/?page=${this.options.page || 1}`,
        headers: {
          /* TODO: NEED TO ADD CREDENTIAL HERE IF WE EVER USE THIS AGAIN */
          Authorization: '',
        },
      };

      this.busy = true;

      this.axios(options)
        .then((res) => {
          this.busy = false;
          this.serverItemsLength = res.data.totalDocs;
          this.chats = res.data.docs.map((cur) => {
            const { createdAt, ...rest } = cur;
            return {
              createdAt: moment(createdAt).local().format('YYYY-MM-DD HH:mm:ss'),
              ...rest,
            };
          });
        })
        .catch((err) => {
          this.busy = false;
        });
    },

    loadAndShowChatDetailDialog(chat) {
      this.chat = chat;
      this.showChatDetailDialog = true;
    },

    closeChatDetailDialog() {
      this.showChatDetailDialog = false;
      this.chat = {};
    },
  },
};
</script>
